import { Component, Input, OnInit, inject } from "@angular/core";
import { JobService } from "@app/integrations/urm/services/job.service";
import { JobFile } from "@app/integrations/urm/models/job-file";
import { MatList, MatListItem } from "@angular/material/list";
import { MatLine } from "@angular/material/core";

@Component({
  selector: "urm-job-contact-widget",
  templateUrl: "./job-contact-widget.component.html",
  styleUrls: ["./job-contact-widget.component.css"],
  imports: [MatList, MatListItem, MatLine]
})
export class JobContactWidgetComponent implements OnInit {
  urmJobService = inject(JobService);

  @Input()
  public externalJobReference: string = null;
  public loading: boolean = true;
  public error: boolean = false;
  public job: JobFile;

  ngOnInit() {
    this.loading = true;
    this.error = false;
    this.urmJobService
      .loadJobById(this.externalJobReference)
      .then((value) => {
        this.loading = false;
        this.error = false;
        this.job = value;
      })
      .catch(() => {
        this.loading = false;
        this.error = true;
      });
  }
}
